import React from 'react';

import {Users, Chats, LargeChat, ActiveUsersService} from 'Components/Networking/Sub';

import ToApi from 'Services/Api/Networking/To';
import UsersApi from 'Services/Api/Networking/Users';

import {translation} from 'Services/TranslationHelpers';
import OrganizationTypeInfo from "Pages/Networking/OrganizationTypeInfo";

import {asset} from 'Services/BaseHelpers';
import AOS from 'aos';
import 'aos/dist/aos.css';

export default class Networking extends React.Component {
    /**
     * @var state
     * @type {{selected_chat: null|object}}
     * @type {{mobile_active_column: string}}
     */
    state = {
        selected_chat: null,
        mobile_active_column: 'users',
        error_message: null,
        usersListKey: 0,
        recommendedUsers: [],
    }

    /**
     * @method componentDidMount
     */
    componentDidMount() {
        ActiveUsersService.subscribe();

        this.fetchInitialUsers();
        this.setSelectedChatOnLoad();

        AOS.init({
            duration: 1000,
            once: true,
            easing: 'ease-in-out',
        });
    };

    /**
     * @method componentWillUnmount
     */
    componentWillUnmount() {
        ActiveUsersService.unsubscribe();
    }

    refreshUsersList = () => {
        this.setState(prev => ({ usersListKey: prev.usersListKey + 1 }));
    }

    fetchInitialUsers = async () => {
        const response = await UsersApi.enabled({filter_by_same_person: true, page: 1});
        if (response && response.data) {
            const recommendedUsers = response.data.data.slice(0, 3);
            this.setState({ recommendedUsers });
        }
    }

    getRowColors(rowSize = 3) {
        const blue = '#DDEDF8';
        return Array(rowSize).fill(blue);
    }

    AttendeeCard({ user, bgColor, fontColor, onChatClick }) {
        const background = bgColor || '#DDEDF8';
        const textColor = fontColor || '#00398A';

        return (
            <div key={user.id} data-aos="fade-up">
                <div
                    className="flex items-stretch rounded-lg overflow-hidden shadow-sm"
                    style={{ background: background }}
                >
                    <div className="w-2/5 flex-shrink-0">
                        {(() => {
                            const src = user.avatar_path && user.avatar_path.url
                                ? user.avatar_path.url
                                : asset('/images/placeholder-profile.png');
                            return (
                                <img
                                    src={src}
                                    alt={user.name}
                                    className="w-full h-full object-cover"
                                />
                            );
                        })()}
                    </div>

                    <div className="flex flex-col flex-grow px-5 py-5 justify-between">
                        <div>
                            <h2 className="text-lg md:text-xl font-bold leading-tight mb-2" style={{ color: textColor }}>
                                {(() => {
                                    const parts = (user.name || '').split(' ');
                                    return (
                                        <>
                                            {parts[0]}
                                            {parts.length > 1 && (
                                                <>
                                                    <br />
                                                    {parts.slice(1).join(' ')}
                                                </>
                                            )}
                                        </>
                                    );
                                })()}
                            </h2>
                            <div className="text-sm" style={{ color: textColor }}>
                                {user.company_name && <span className="font-bold block">{user.company_name}</span>}
                                {user.company_name && user.job_title && <span className="block">{user.job_title}</span>}
                                {!user.company_name && user.job_title && <span className="block">{user.job_title}</span>}
                            </div>
                        </div>

                        <div className="mt-4 flex justify-end">
                            <span
                                className="font-bold cursor-pointer inline-flex items-center text-sm"
                                onClick={() => onChatClick(user)}
                                style={{ color: textColor }}
                            >
                                Connect with me<span className="ml-1">→</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    /**
     * @method setSelectedChatOnLoad
     */
    setSelectedChatOnLoad = async () => {
        const {selectedMessageToType, selectedMessageToId} = this.props;

        if (selectedMessageToType && selectedMessageToId) {
            const response = await ToApi.get(selectedMessageToId, {
                message_to_type: selectedMessageToType
            });

            if (response.success) {
                this.setSelectedChat(response.data.data);
            } else {
                this.setState({
                    error_message: 'Invalid pre-select'
                });
            }
        }
    }

    /**
     * @method setSelectedChat
     * @param {object} user
     */
    setSelectedChat = (user) => {
        this.setState({
            selected_chat: user,
            mobile_active_column: 'chat'
        });
    }

    /**
     * @method getColumns
     * @return {array}
     */
    getColumns = () => {
        return {
            'users': {
                component: Users,
                className: 'w-full lg:w-3/12 py-2  h-full bg-app-networking'
            },
            'chats': {
                component: Chats,
                className: 'w-full lg:w-3/12 py-2  bg-app-networking'
            },
            'chat': {
                component: LargeChat,
                className: 'w-full lg:w-6/12 py-2  bg-app-networking'
            }
        };
    }

    /**
     * @method render
     * @return {*}
     */
    render() {
        const {error_message, recommendedUsers} = this.state;

        if (error_message) {
            return (
                <div className="text-center font-bold">
                    {error_message}
                </div>
            );
        }

        return (
            <div>
                <div className=" mt-12 text-center text-2xl font-bold mx-auto text-app-blue">
                    {/*<img*/}
                    {/*    src={asset('images/agenda-date-banner.gif')}*/}
                    {/*    alt="Agenda Date Banner"*/}
                    {/*    className="w-full h-24 object-cover mt-2 p-4 max-w-4xl mx-auto"*/}
                    {/*/>*/}
                    Make a connection
                </div>

                <p className={ "mt-5 mb-12 max-w-7xl text-center mx-auto text-app-blue" }>
                    To start networking, search for a contact and send a message.
                </p>


                {recommendedUsers.length > 0 && (
                    <div className="max-w-5xl mx-auto px-5 my-14">
                        <h2
                            className="text-4xl text-app-light-blue mb-6 text-left"
                            data-aos="fade-up"
                            data-aos-delay="0"
                        >
                            Recommended for you
                        </h2>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 w-full mx-auto"
                             data-aos="fade-up"
                             data-aos-delay="1400">
                            {Array.from({ length: Math.ceil(recommendedUsers.length / 3) }).map((_, rowIdx) => {
                                const rowColors = this.getRowColors();
                                return recommendedUsers.slice(rowIdx * 3, rowIdx * 3 + 3).map((user, colIdx) => {
                                    const bgColor = rowColors[colIdx];
                                    const fontColor = '#00398A';

                                    return this.AttendeeCard({
                                        user,
                                        bgColor,
                                        fontColor,
                                        onChatClick: this.setSelectedChat,
                                        key: user.id,
                                        'data-aos': 'fade-up',
                                        'data-aos-delay': (rowIdx * 3 + colIdx) * 100
                                    });
                                });
                            })}
                        </div>
                    </div>
                )}

                <div className="networking-container h-full flex flex-col lg:flex-row bg-app-gray">
                    { this.renderMobileControls () }
                    { this.renderColumns () }
                </div>
            </div>
        );
    }

    /**
     * @method renderMobileControls
     * @return {*}
     */
    renderMobileControls() {
        const { mobile_active_column } = this.state;

        let columns = Object.entries ( this.getColumns () );

        return (
            <div className="z-10 min-w-full h-11 grid grid-cols-3 lg:hidden">
                { columns.map ( ( column, i ) => (
                    <div
                        className={ `
                            p-2 large text-center cursor-pointer border border-networking-primary
                            ${mobile_active_column === column[0] ?
                                'bg-networking-primary text-app-blue' :
                                'bg-networking-primary-text text-app-blue'}
                        `}
                        onClick={() => this.setState({mobile_active_column: column[0]})}
                        key={i}
                    >
                        {translation('networking_frontend', column[0] + '_title')}
                    </div>
                ))}
            </div>
        );
    }

    /**
     * @method renderColumns
     * @return {*}
     */
    renderColumns() {
        const {useGroups = true} = this.props;
        const {mobile_active_column, selected_chat} = this.state;

        let columns = Object.entries(this.getColumns());

        return (
            <div className="flex min-w-full h-screen max-h-[65em]">
                {columns.map((column, i) => {
                    let Component = column[1].component;
                    let extraProps = {};
                    if (column[0] === 'users') {
                        extraProps.key = this.state.usersListKey;
                    }
                    return (
                        <div
                            className={`
                                ${column[1].className}
                                ${mobile_active_column === column[0] ? 'inline' : 'hidden'}
                                lg:inline
                            `}
                            key={i}
                        >
                            <Component
                                setSelectedChat={(user) => this.setSelectedChat(user)}
                                selected_chat={selected_chat}
                                useGroups={useGroups}
                                {...extraProps}
                            />
                        </div>
                    );
                })}
            </div>
        );
    }
}
